import React, { Component } from 'react';
import symplImg from './../../../statics/img/payment_methods_logos/Sympl.png';
import './../../custom.css';
import './message.css';

class message extends Component {
    render_circle = (num, width) => {
		let final_num = parseInt(num * 360);
		let arr = [];
		for(let x = 0; x < 360; x++){
			if(x <= final_num){arr.push(true);}else{arr.push(false);}
		}
		let final_circle = 
			<svg height={width} width={width} class="custom_circle">
				{arr.map((ele, index)=>{
                    let x = (width/2) + (width/2) * Math.cos(index * (Math.PI/180));
                    let y = (width/2) + (width/2) * Math.sin(index * (Math.PI/180));
                    return ele ? 
                        <line key={index} className="active" x1={(width/2)} y1={(width/2)} x2={x} y2={y} style={{stroke_width:1}} />
                    :
                        <line key={index} x1={(width/2)} y1={(width/2)} x2={x} y2={y} style={{stroke_width:1}} />
                })}
				Sorry, your browser does not support inline SVG.
			</svg>;
			return final_circle;
									
	}
    render_sympl_success = () => {
        return(
            <div className="installmentsDiv">
                <div className="installmentsHead">                            
                    <img src={symplImg} />
                    <p>Transaction successful!</p>
                </div>
                <div id="congratulions_page" className="congrat_page">
                    <div className="congrat_head">
                        <p className="text">
                            We charged a total of <span id="end_fee">EGP 100</span> now & your upcoming <br/>
                            payments will be automatically charged from your card
                        </p>
                    </div>
                    <div className="timeline_congrat_page">
                        <p className="tille">Your <strong>0%</strong> interest payment plan details</p>
                        <div id="render_timeline_last_page">
                            <div class="plan_div">
                                {this.render_circle(1/3, 25)}
                                <span class="date">2021-10-01</span>
                                <span class="amount">40 EGP</span>
                            </div>
                            <div class="plan_div">
                                {this.render_circle(2/3, 25)}
                                <span class="date">2021-11-01</span>
                                <span class="amount">40 EGP</span>
                            </div>
                            <div class="plan_div">
                                {this.render_circle(3/3, 25)}
                                <span class="date">2021-12-01</span>
                                <span class="amount">40 EGP</span>
                            </div>

                            <div class="total_div">
                                <span class="text">Total</span>
                                <span class="amount">750 EGP</span>
                            </div>
                            <span class="plans_row"></span>
                        </div>
                        <p className="thanks">Thank you for shopping with Sympl</p>
                        <p className="recieve_sms">You will receive a SMS with details <br/><span>For info, <a href="#" target="_blank">download Sympl app</a></span></p>
                    </div>
                </div>
            </div>
        )
    }
    render(){
        return (
            this.props.sympl ?
                <div className="message">
                    <div className='container2'>
                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 gridMessage'>
                            {this.render_sympl_success()}
                        </div>
                    </div>          
                </div>
            :
                <div className="message">
                    <div className='container2'>
                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 gridMessage'>
                            <div className="text-center payS" style={{padding: '20px'}}>
                                {this.props.head? <jumbo>{this.props.head}</jumbo>: null}
                                {this.props.body? <h4>{this.props.body}</h4>: null}
                            </div>
                        </div>
                    </div>          
                </div>
        );
    }
}

export default message;
